import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import Notifications from '../../services/notifications';
import { compose } from '../../services/utilityFunctions';
import withCSRF from '../withCSRF';
import Modal from './Modal';
import ModalHeader from './ModalHeader';
import ModalFooter from './ModalFooter';
import translate from '../translate';
import FormInput from '../forms/FormInput';

function SponsorUserChangeModal({ t, _csrf, userId, sponsoredBy, onClose }) {
  const [sponsorUserId, setSponsorUserId] = useState(null);

  const handleChangeSponsorUser = () => {
    axios
      .put(
        `/api/user/direct-selling/${userId}/sponsor/user?populate=organization&populate=sponsoredBy`,
        {
          sponsoredBy: sponsorUserId === 'none' ? null : sponsorUserId,
        },
        {
          headers: {
            'Accept-Version': '1.0.0',
            'X-Gamification-API': 'Organization',
            'X-CSRF-Token': _csrf,
            _csrf,
          },
        },
      )
      .then(({ data: response }) => {
        onClose(response.data);
        Notifications.showNotificationSuccess(
          t('success'),
          t('sponsor.success.update'),
        );
      })
      .catch(err => {
        Notifications.showErrorFromRequest(t(err), 'sponsor.error.update');
      });
  };

  let endpoint = '/user/table/network/list?allowNone=true&includeMe=true';
  if (userId) {
    endpoint += `&exceptIds[]=${userId}`;
  }
  if (sponsoredBy) {
    endpoint += `&exceptIds[]=${sponsoredBy}`;
  }
  return (
    <Modal id="userChangeSponsorModal" onClose={() => onClose(null)}>
      <div className="modal-dialog">
        <div className="modal-content">
          <ModalHeader
            title={t('modal.change_sponsor_user')}
            onClose={() => onClose(null)}
          />
          <div className="modal-body">
            <div className="container-fluid">
              <div className="portlet-body form">
                <div className="row">
                  <div className="col-md-12 form-group">
                    <label
                      htmlFor="roleSelector"
                      className="col-md-12 control-label text-left"
                    >
                      {t('profile_sponsoredBy')}
                    </label>
                    <div className="col-md-12">
                      <FormInput
                        id="userSponsor"
                        name="userSponsor"
                        onChange={uId => {
                          setSponsorUserId(uId);
                        }}
                        value={sponsorUserId}
                        type="users"
                        inputProps={{
                          allowClear: false,
                          url: endpoint,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <ModalFooter
            onSave={handleChangeSponsorUser}
            onCancel={() => onClose(null)}
            saveText={t('confirm')}
            cancelText={t('cancel')}
            saveIsLoader
            disabled={!sponsorUserId}
          />
        </div>
      </div>
    </Modal>
  );
}

SponsorUserChangeModal.propTypes = {
  t: PropTypes.func.isRequired,
  _csrf: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  sponsoredBy: PropTypes.string,
  onClose: PropTypes.func.isRequired,
};

SponsorUserChangeModal.defaultProps = {
  sponsoredBy: '',
};

export default compose(translate, withCSRF)(SponsorUserChangeModal);
